import React, { useEffect, MouseEventHandler } from "react";
import { Label, FormText } from "reactstrap";
import { getClubs } from "../../../../../Lib/RESTBlox";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
} from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import VenueModal from "../../../../../Components/Admin/Modals/VenueModal";

const SortableMultiValue = SortableElement((props: MultiValueProps) => {
  const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableMultiValueLabel = SortableHandle(
  (props: MultiValueGenericProps) => <components.MultiValueLabel {...props} />
);

type Props2 = {
  field: any;
  form: any;
  label: boolean;
  required: boolean;
  help: any;
  placeholder: any;
  disabled: any;
};

const FormVenuePicker: React.FC<Props2> = ({
  field,
  form,
  label,
  required,
  help,
  placeholder,
  disabled,
}) => {
  const [value, setValue] = React.useState<any>(field.value);
  const [venues, setVenues] = React.useState<any[]>([]);
  const [page, setPage] = React.useState<number>(1);

  const handleChange = (value: any) => {
    console.log(value);
    setValue(value);
    form.setFieldValue(field.name, value.value);
    return { value };
  };

  const handleGetMore = (value: any) => {
    getItems(page);
  };

  useEffect(() => {
    getItems();
  }, []);

  const getItems = (page = 0) => {
    getClubs(page + 1)
      .then((data: any) => {
        var fetchedVenues = data?.results?.map((venue: any, i: number) => {
          return {
            value: venue.id,
            label: venue.name + ", " + venue.address,
          };
        });
        setPage(page + 1);
        setVenues(venues.concat(fetchedVenues));
        if (field.value) {
        }
      })
      .catch((err) => console.error(err));
  };

  const promiseOptions = (inputValue: string) => {
    getClubs(1, inputValue)
      .then((data: any) => {
        var fetchedPromoters = data.results.map((venue: any, i: number) => {
          return {
            value: venue.id,
            label: venue.name + ", " + venue.address,
          };
        });
        setVenues(fetchedPromoters);
      })
      .catch((err) => console.error(err));
  };

  const handleNewVenue = (venue: any) => {
    var new_venue = {
      value: venue.id,
      label: venue.name + ", " + venue.address,
    };
    setVenues([...venues, new_venue]);
    handleChange(new_venue);
  };

  return (
    <>
      <Label for={field.name}>
        {label}
        {required ? (
          <span className="required">*</span>
        ) : (
          <span className="optional">Optional</span>
        )}
      </Label>
      <Select
        onMenuScrollToBottom={handleGetMore}
        onInputChange={promiseOptions}
        options={venues}
        value={value}
        onChange={handleChange}
        components={{
          MultiValue: SortableMultiValue,
          MultiValueLabel: SortableMultiValueLabel,
        }}
        closeMenuOnSelect={false}
      />
      <FormText>
        Don't see your venue?
        <VenueModal
          buttonText="Add venue"
          block={false}
          outline={false}
          handleNewVenue={handleNewVenue}
        />
        {help}
      </FormText>
      <div
        className={
          form.touched[field.name] && form.errors[field.name]
            ? "error active"
            : "error inactive"
        }
      >
        {form.touched[field.name] && form.errors[field.name] ? (
          <span>{form.errors[field.name]}</span>
        ) : (
          <span>&nbsp;</span>
        )}
      </div>
      {help && <FormText>{help}</FormText>}
    </>
  );
};

export default FormVenuePicker;
